import script from "./ProductsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductsPage.vue?vue&type=style&index=0&id=932837be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-932837be"]])

export default __exports__